import { Outlet, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { CampaignActivationModal } from '@forwardflow/modals/CampaignActivationModal'

import TopBar from '../ActivateCampaign/TopBar'
import { LeadSourceInfo } from '../ActivateCampaign/LeadSourceInfo'
import { NavigationBar } from '../ActivateCampaign/NavigationBar'
import { useGetActiveLeadSourceDetails } from '@forwardflow/hooks/customHooks'
import CampaignService from '@forwardflow/services/CampaignService'
import { CampaignLiveModal } from '@forwardflow/modals/CampaignLiveModal'

export const ConfigCampaign = () => {
   const { title } = useParams()

   const { data: organizationCampaignDetails } = useGetActiveLeadSourceDetails(
      title as string
   )

   useEffect(() => {
      const handleBeforeUnload = () => {
         CampaignService.discardDraftCampaign(title as string)
      }

      window.addEventListener('beforeunload', handleBeforeUnload)

      return () => {
         window.removeEventListener('beforeunload', handleBeforeUnload)
         CampaignService.discardDraftCampaign(title as string)
      }
   }, [title])

   return (
      <>
         <TopBar />

         <>
            <div className="flex gap-5 mt-5">
               <LeadSourceInfo />
               <div className="flex flex-1 gap-5 bg-primary/10 rounded-xl">
                  <NavigationBar />
                  <Outlet></Outlet>
               </div>
            </div>
            {organizationCampaignDetails &&
               organizationCampaignDetails?.status === 'draft' && (
                  <>
                     <CampaignActivationModal />
                  </>
               )}
            <CampaignLiveModal />
         </>
      </>
   )
}
